module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('h4', [_vm._v("Samsung Promotool")]), _vm._v(" "), _c('div', {
    staticClass: "login-inner"
  }, [_c('h3', [_vm._v("Inloggen")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Wachtwoord"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.signIn,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.signIn($event)
      }
    }
  }, [_vm._v("Inloggen")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37dc28e6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 228
// module chunks = 1